import { createSlice } from "@reduxjs/toolkit";
import { getClients } from "./thunk";

const getAllClientSlice = createSlice({
    name: "getClients",
    initialState: {
        isLoading: false,
        isError: false,
        clientsList: [],
    },
    extraReducers: (builder) => {
        builder.addCase(getClients.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getClients.fulfilled, (state, action) => {
            state.isLoading = false;
            state.clientsList = action.payload;
        });
        builder.addCase(getClients.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });
    }
});

export default getAllClientSlice.reducer;